import { AppStateModel } from './+redux/redux.models';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { ConfigurationService, ForceBaseUrl } from './configuration/configuration.service';
import { Utilities } from './utilities';
import { Store } from '@ngxs/store';
import { be } from '@fullcalendar/core/internal-common';

export abstract class EndpointFactory {
    static readonly apiVersion: string = '1';

    get baseUrl() {
        const { baseUrl } = EndpointFactory.getUrl(this.relativeName, (this.baseUrlParam || this.configurations.baseUrl))
        return baseUrl;
    }

    get url() {
        const { url } = EndpointFactory.getUrl(this.relativeName, (this.baseUrlParam || this.configurations.baseUrl))
        return url;
    }

    private _store: Store;
    private get store() {
        if(! this._store){
            this._store = this.injector.get(Store);
        }
        return this._store;
    }

    constructor(protected http: HttpClient,
                protected configurations: ConfigurationService,
                private injector: Injector,
                public relativeName?: string,
                private baseUrlParam?: (() => string) | string) { }

    private static getUrl(relativeName: string, baseUrlParam?: (() => string) | string) {
        let baseUrl: string;
        baseUrl = typeof (baseUrlParam) === 'function' ? baseUrlParam() : baseUrlParam;
        baseUrl = Utilities.removeEndChar(baseUrl, '\\');
        baseUrl = Utilities.removeEndChar(baseUrl, '/');

        const url = baseUrl + '/' + relativeName;

        return { url, baseUrl };
    }

    protected getBaseUrl(requestCategory: string, force?: ForceBaseUrl) {
        return this.configurations.getBaseUrl(requestCategory, force);
    }

    protected handleError(error) {

        if (error.status === 401) {
            return throwError('session expired');
        }
        return throwError(error);
    }

}
